import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FormatCurrencyPipe } from '../../../../../../shared/pipes/format-currency.pipe';

export interface QuoteCostItem {
  concept: string;
  cost: number;
}

@Component({
  selector: 'app-quote-cost-card',
  imports: [FormatCurrencyPipe, MatIcon],
  templateUrl: './quote-cost-card.component.html',
  styleUrl: './quote-cost-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteCostCardComponent {
  readonly deliveryType = input.required<string>();
  readonly deliveryDate = input.required<string>();
  readonly quoteId = input.required<string>();
  readonly currency = input.required<string>();
  readonly costBreakdown = input.required<QuoteCostItem[]>();
  readonly totalCost = input.required<number>();
  readonly recommendedPOTotal = input<number | null>(null);
  readonly costDeltas = input<ReadonlyMap<string, number>>(new Map());
  readonly summaryOnly = input(false);

  getCostDelta(concept: string): number | null {
    return this.costDeltas().get(concept) ?? null;
  }
}
